__turbopack_context__.v({
  "big": "team-member-module__kFVojG__big",
  "image": "team-member-module__kFVojG__image",
  "name": "team-member-module__kFVojG__name",
  "profile": "team-member-module__kFVojG__profile",
  "ready": "team-member-module__kFVojG__ready",
  "teamMember": "team-member-module__kFVojG__teamMember",
});
